import PublicationsCard from "./sharedCards/PublicationsCard";
import VariantDetailsCard from "./variantPageCards/VariantDetailsCard";
import AmpCard from "./variantPageCards/AmpCard";
import ACMGCard from "./variantPageCards/ACMGCard";
import {
  AggregateCard,
  ICGCSomaticCard,
  CancerHotSportsCard,
  GDCCard,
  CBioPortalCard,
  COSMICCard,
  IARCTP53SomaticCard,
  IARCTP53GermlineCard,
} from "./variantPageCards/CancerSamplesCard/index";
import DoCM from "../../pages/variant/components/cancer-dbs/DoCM/DoCM";
import DoCMCard from "./variantPageCards/DoCMCard";
import PharmGKBVariantCard from "./variantPageCards/PharmGKBVariantCard/PharmGKBVariantCard";
import CommunityContributionsVariantCard from "./variantPageCards/community-contributions";
import StructuralVariantsCard from "./sharedCards/StructuralVariantsCard";
import RegionBrowserCard from "./sharedCards/RegionBrowserCard";
import ExpressionDataCard from "./variantPageCards/ExpressionDataCard";
import beaconNetworkCard from "./variantPageCards/BeaconNetworkCard";
import ClinVarCard from "./variantPageCards/ClinVarCard";
import GeneCard from "./variantPageCards/GeneCard";
import GwasCard from "./variantPageCards/GwasCard";
import FrequenciesCard from "./variantPageCards/FrequenciesCard";
import Card from "./Card";
import ConservationScoresCard from "./variantPageCards/ConservationScoresCard";
import PathogenicityScoresCard from "./variantPageCards/PathogenicityScoresCard";
import UniProtCard from "./variantPageCards/UniProtCard/UniProtCard";
import TranscriptDetailsCard from "./transcriptPageCards/TranscriptDetailsCard";
import AdditionalRangeLinksCard from "./transcriptPageCards/AdditionalRangeLinksCard";
import TranscriptsCard from "./variantPageCards/TranscriptsCard";
import JAXCKBCard from "./variantPageCards/JAXCKBCard";
import CIVICCard from "./variantPageCards/CIVICCard";
import PMKBCard from "./variantPageCards/PMKBCard";
import VariantIntro from "../../pages/variant/VariantIntro";
import CancerChartsAggregator from "../../pages/variant/components/CancerChartsAggregator/CancerChartsAggregator";
import IcgcSomatic from "../../pages/variant/components/ICGC/IcgcSomatic";
import CancerHotspots from "../../pages/variant/components/CancerHotspots";
import GDCComponent from "../../pages/variant/components/GDC/GDCComponent";
import CBioPortal from "../../pages/variant/components/CBioPortal/CBioPortal";
import SangerCosmicLicensed from "../../pages/variant/components/SangerCosmicLicensed";
import IARCTP53Germline from "../../pages/variant/components/cancer-dbs/IARCTP53Germline/IARCTP53Germline";
import IARCTP53Somatic from "../../pages/variant/components/cancer-dbs/IARCTP53Somatic/IARCTP53Somatic";
import UniprotVariants from "../../pages/variant/components/UniprotVariants";
import Civic from "../../pages/variant/components/cancer-dbs/CIVIC/Civic";
import JaxCkbComponent from "../../pages/variant/components/JaxCKB/JaxCkbComponent";
import PMKB from "../../pages/variant/components/cancer-dbs/PMKB/PMKB";
import PharmGKB from "../../pages/variant/components/PharmGKB/PharmGKB";
import Publications from "../Publications/components/MainPublications";
import CommunityContributions from "../../pages/variant/components/CommunityContributions/CommunityContributions";
import StructuralBrowser from "../../browsers/StructuralBrowser";
import RegionBrowser from "../../browsers/RegionBrowser";
import BeaconNetwork from "../../pages/variant/components/BeaconNetwork";
import GTEx from "../../pages/variant/components/GTEx/GTEx";
import ClinGenCard from "./variantPageCards/ClinGenCard/ClinGenCard";
import LovdCard from "./variantPageCards/LovdCard/LovdCard";
import NcbiClinvar2 from "../../pages/variant/components/NcbiClinvar2/NcbiClinvar2";
import ConservationScores from "../../pages/variant/components/ConservationScores/ConservationScores";
import Genes from "../../pages/variant/components/Genes";
import GWAS from "../../pages/variant/components/GWAS/GWAS";
import Frequencies from "../../pages/variant/components/frequencies/Frequencies";
import TranscriptDetails from "../../pages/transcript/TranscriptDetails";
import AdditionalRangeLinks from "../AdditionalRangeLinks";
import Transcripts from "../../pages/variant/components/transcripts/Transcripts";
import CnvDetailsContainer from "../../pages/cnvs/CnvDetailsContainer";
import CNVDetailsCard from "./cnvPageCards/CNVDetailsCard";
import CNVTranscriptsCard from "./cnvPageCards/TranscriptsCard";
import CNVTranscripts from "../../pages/cnvs/components/CNVTranscripts";
import CnvACMG from "../../pages/variant/components/CnvACMG/CnvACMG";
import CnvAcmgClassificationCard from "./cnvPageCards/CnvAcmgClassificationCard";
import CnvRegionBrowserCard from "./cnvPageCards/CnvRegionBrowserCard";
import ProteinViewerCard from "./sharedCards/ProteinViewerCard";
import ProteinViewerContainer from "../3d-protein-viewer/ProteinViewerContainer";
import MitomapCard from "./variantPageCards/MitoMapCard";
import Mitomap from "../../pages/variant/components/frequencies/Mitomap";
import { setProteinViewerState } from "../../state/actions/genericActions";
import OMIMCard from "./variantPageCards/OMIMCard";
import OmimVariant from "../OMIM/OmimVariant";
import store from "../../state/store";
import InsilicoPredictionsWrapper from "../../pages/variant/components/InSilicoPredictions/InsilicoPredictionsWrapper";
import NihClinGenVariants from "../../pages/variant/components/NihClinGenVariants/NihClinGenVariants";
import Lovd from "../../pages/variant/components/Lovd/Lovd";
import DVDCard from "./variantPageCards/DVDCard/DVDCard";
import DVD from "../../pages/variant/components/DVD";
import SampleView from "../../browsers/SampleViewBrowser/EmulateClinical";
import ExomeDepthCnvBrowser from "../../browsers/ExomeDepthCnvBrowser/EmulateClinical";
import DellyCnvBrowser from "../../browsers/DellyCnvBrowser/EmulateClinical";
import DisclaimerWrapperACMG from "../../pages/variant/components/acmg/acmg-disclaimer";
import DisclaimerWrapperAMP from "../../pages/variant/components/AMP/DisclaimerWrapperAMP";
import PortalPublications from "../Publications/components/PortalPublications/EmulateClinical";
import OncoKBVariant from "../../pages/variant/components/OncoKB/OncoKBVariant";
import OncoKBCard from "./variantPageCards/OncoKBCard/OncoKBCard";
import SpliceAiCard from "./variantPageCards/SpliceAiCard";
import SpliceVault from "../../pages/variant/components/SpliceVault";

const general = "general";
const amp = "amp";
const acmg = "acmg";
const misc = "misc";

const defaultCat = misc;

function getCategoryMap(cardItems) {
  return cardItems.reduce(
    (a, i) =>
      a.set(i.category || defaultCat, [
        ...(a.get(i.category || defaultCat) || []),
        i,
      ]),
    new Map()
  );
}

const cardsArr = [
  {
    id: "variantDetails",
    title: "General Information",
    category: general,
    CardComp: VariantDetailsCard,
    Comp: VariantIntro,
  },
  {
    id: "amp",
    title: "Somatic Classification",
    category: amp,
    isPremium: true,
    defaultCardColor: "black",
    CardComp: AmpCard,
    Comp: DisclaimerWrapperAMP,
  },
  {
    id: "acmg",
    title: "Germline Classification",
    category: acmg,
    CardComp: ACMGCard,
    Comp: DisclaimerWrapperACMG,
  },
  {
    id: "cancerSamplesAggregateCard",
    title: "Cancer Samples Summary",
    category: amp,
    CardComp: AggregateCard,
    Comp: CancerChartsAggregator,
  },
  {
    id: "cancerSamplesICGCSomatic",
    title: "ICGC Somatic",
    category: amp,
    CardComp: ICGCSomaticCard,
    Comp: IcgcSomatic,
  },
  {
    id: "cancerSamplesCancerHotspots",
    title: "Cancer Hotspots",
    category: amp,
    CardComp: CancerHotSportsCard,
    Comp: CancerHotspots,
  },
  {
    id: "cancerSamplesGDC",
    title: "GDC",
    category: amp,

    CardComp: GDCCard,
    Comp: GDCComponent,
  },
  {
    id: "cancerSamplescBioPortal",
    title: "cBioPortal",
    category: amp,
    CardComp: CBioPortalCard,
    Comp: CBioPortal,
  },
  {
    id: "cancerSamplesIARCTP53Germline",
    title: "IARC TP53 Germline",
    CardComp: IARCTP53GermlineCard,
    Comp: IARCTP53Germline,
    category: acmg,
  },
  {
    id: "cancerSamplesIARCTP53Somatic",
    title: "IARC TP53 Somatic",
    CardComp: IARCTP53SomaticCard,
    Comp: IARCTP53Somatic,
    category: amp,
  },
  {
    id: "uniprotVariants",
    title: "Uniprot Variants",
    CardComp: UniProtCard,
    category: acmg,
    Comp: UniprotVariants,
  },
  {
    id: "civic",
    title: "CIViC",
    category: amp,
    isPremium: false,
    CardComp: CIVICCard,
    Comp: Civic,
  },
  {
    id: "jaxckb",
    title: "JAX CKB",
    category: amp,
    isPremium: false,
    CardComp: JAXCKBCard,
    Comp: JaxCkbComponent,
  },
  {
    id: "pmkb",
    title: "PMKB",
    category: amp,
    isPremium: false,
    CardComp: PMKBCard,
    Comp: PMKB,
  },
  {
    id: "pharmGKB",
    title: "PharmGKB",
    category: amp,
    isPremium: true,
    CardComp: PharmGKBVariantCard,
    Comp: PharmGKB,
  },
  {
    id: "publications",
    title: "Publications",
    category: general,
    CardComp: PublicationsCard,
    Comp: Publications,
  },
  {
    id: "communityContributions",
    title: "Community Contributions",
    category: general,
    CardComp: CommunityContributionsVariantCard,
    Comp: CommunityContributions,
  },
  {
    id: "structuralVariants",
    title: "Structural Variants",
    category: misc,
    CardComp: StructuralVariantsCard,
    Comp: StructuralBrowser,
    isNew: false,
  },
  {
    id: "regionBrowser",
    title: "Region Browser",
    category: general,
    CardComp: RegionBrowserCard,
    Comp: RegionBrowser,
    isNew: false,
  },
  {
    id: "beaconNetwork",
    title: "Beacon Network",
    CardComp: beaconNetworkCard,
    Comp: BeaconNetwork,
  },
  {
    id: "expressionData",
    title: "Expression Data",
    CardComp: ExpressionDataCard,
    Comp: GTEx,
  },
  {
    id: "pathogenicityScores",
    title: "In-Silico Predictors",
    CardComp: PathogenicityScoresCard,
    Comp: InsilicoPredictionsWrapper,
    category: acmg,
  },
  {
    id: "clinVar",
    title: "ClinVar",
    category: acmg,
    CardComp: ClinVarCard,
    Comp: NcbiClinvar2,
  },
  {
    id: "lovd",
    title: "LOVD",
    category: acmg,
    CardComp: LovdCard,
    Comp: Lovd,
    isNew: false,
    isPremium: true,
  },
  {
    id: "conservationScores",
    title: "Conservation Scores",
    category: acmg,
    CardComp: ConservationScoresCard,
    Comp: ConservationScores,
  },
  {
    id: "genes",
    title: "Genes",
    category: general,
    CardComp: GeneCard,
    Comp: Genes,
  },
  {
    id: "gwas",
    title: "GWAS",
    CardComp: GwasCard,
    Comp: GWAS,
  },
  {
    id: "frequencies",
    title: "Frequencies",
    category: acmg,
    CardComp: FrequenciesCard,
    Comp: Frequencies,
  },
  {
    id: "mitomap",
    title: "MitoMap",
    category: acmg,
    CardComp: MitomapCard,
    Comp: Mitomap,
  },
  {
    id: "transcriptDetails",
    title: "Transcript details",
    category: general,
    CardComp: TranscriptDetailsCard,
    Comp: TranscriptDetails,
  },
  {
    id: "additionalRangeLinks",
    title: "Additional resources",
    CardComp: AdditionalRangeLinksCard,
    Comp: AdditionalRangeLinks,
  },
  {
    id: "transcripts",
    title: "Transcripts",
    category: general,
    CardComp: TranscriptsCard,
    Comp: Transcripts,
  },
  {
    id: "cnvDetails",
    title: "CNV Details",
    CardComp: CNVDetailsCard,
    Comp: CnvDetailsContainer,
  },
  {
    id: "acmgCnvClassification",
    title: "CNV Classification",
    CardComp: CnvAcmgClassificationCard,
    Comp: CnvACMG,
    category: acmg,
  },
  {
    id: "cnvTranscripts",
    title: "Transcripts",
    category: general,
    CardComp: CNVTranscriptsCard,
    Comp: CNVTranscripts,
  },
  {
    id: "cnvRegionBrowser",
    title: "Structural Variants",
    CardComp: CnvRegionBrowserCard,
    Comp: StructuralBrowser,
    isNew: false,
  },
  {
    id: "proteinViewer",
    title: "Protein Viewer",
    category: misc,
    disableScroll: true,
    CardComp: ProteinViewerCard,
    Comp: ProteinViewerContainer,
    onSelectHooks: [() => store.dispatch(setProteinViewerState(true))],
  },
  {
    id: "docm",
    title: "DoCM",
    category: amp,
    CardComp: DoCMCard,
    Comp: DoCM,
  },
  {
    id: "omim",
    title: "OMIM ®",
    CardComp: OMIMCard,
    Comp: OmimVariant,
    category: acmg,
    isPremium: true,
    isNew: false,
  },
  {
    id: "spliceVault",
    title: "SpliceVault",
    CardComp: SpliceAiCard,
    Comp: SpliceVault,
    category: misc,
    isPremium: false,
    isNew: true,
  },
  {
    id: "clinGen",
    title: "ClinGen",
    category: acmg,
    CardComp: ClinGenCard,
    Comp: NihClinGenVariants,
    isNew: false,
  },
  {
    id: "dvd",
    title: "Deafness Variation Database",
    category: acmg,
    CardComp: DVDCard,
    Comp: DVD,
    isNew: true,
  },
  {
    id: "cancerSamplesCOSMICLicensed",
    title: "Cosmic",
    isPremium: true,
    category: amp,
    CardComp: COSMICCard,
    Comp: SangerCosmicLicensed,
  },
  {
    id: "sampleView",
    title: "Sample View",
    category: general,
    CardComp: RegionBrowserCard,
    Comp: SampleView,
    disableScroll: true,
    preventClinicalRemount: true,
  },
  {
    id: "cnvBrowser",
    title: "CNV Browser",
    category: general,
    CardComp: RegionBrowserCard,
    Comp: ExomeDepthCnvBrowser,
    disableScroll: true,
    preventClinicalRemount: true,
  },
  {
    id: "dellyCNVBrowser",
    title: "Delly CNV Browser",
    category: general,
    CardComp: RegionBrowserCard,
    Comp: DellyCnvBrowser,
    disableScroll: true,
    preventClinicalRemount: true,
  },
  {
    id: "portalPublications",
    title: "Publications Clinical",
    category: null,
    CardComp: PublicationsCard,
    Comp: PortalPublications,
    disableScroll: true,
    preventClinicalRemount: true,
  },
  {
    id: "oncoKB",
    title: "OncoKB",
    category: amp,
    CardComp: OncoKBCard,
    Comp: OncoKBVariant,
    isNew: true,
    isPremium: true,
  },
];

const addClinicalCards =
  process.env.NODE_ENV === "development" &&
  window.location.origin === "http://local.varsome.com:3000" &&
  localStorage.getItem("emulate-clinical");

export const cards = cardsArr
  .map((x) => new Card(x))
  .reduce((a, i) => ({ ...a, [i.id]: i }), {});

export function groupCards(cardItems, columns) {
  const groups = getCategoryMap(cardItems);
  const generalCards = groups.get(general) || [];
  const miscCards = groups.get(misc) || [];
  const acmgCards = groups.get(acmg) || [];
  const ampCards = groups.get(amp) || [];
  const strongGroups = [ampCards, acmgCards];
  const maxStrong = columns - 2;
  const downgraded = strongGroups.slice(maxStrong);
  const weak = [generalCards, ...downgraded, miscCards];
  return {
    weakCards: weak.reduce((a, i) => [...a, ...i], []),
    strongColumns: strongGroups.slice(0, maxStrong),
  };
}

export const variantPageCardsSomaticUnordered = [
  cards.variantDetails,
  cards.genes,
  cards.amp,
  cards.oncoKB,
  cards.jaxckb,
  cards.civic,
  cards.docm,
  cards.pmkb,
  cards.cancerSamplesAggregateCard,
  cards.cancerSamplesCOSMICLicensed,
  cards.cancerSamplesICGCSomatic,
  cards.cancerSamplesCancerHotspots,
  cards.cancerSamplesGDC,
  cards.cancerSamplescBioPortal,
  cards.cancerSamplesIARCTP53Somatic,
  cards.pharmGKB,
  cards.acmg,
  cards.clinVar,
  cards.lovd,
  cards.frequencies,
  cards.mitomap,
  cards.dvd,
  cards.cancerSamplesIARCTP53Germline,
  cards.conservationScores,
  cards.uniprotVariants,
  cards.communityContributions,
  cards.publications,
  cards.transcripts,
  cards.pathogenicityScores,
  // cards.spliceVault,
  cards.expressionData,
  cards.gwas,
  cards.regionBrowser,
  cards.structuralVariants,
  cards.beaconNetwork,
  cards.proteinViewer,
  cards.omim,
  cards.clinGen,
];

// including tp53 cards
export const variantPageCardsSomatic = [
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === general),
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === amp),
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === acmg),
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === misc),
];

export const variantPageCardsSomaticNonTp53 = [
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === general),
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === amp),
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === acmg),
  ...variantPageCardsSomaticUnordered.filter((x) => x.category === misc),
].filter((x) => {
  return (
    x.id !== "cancerSamplesIARCTP53Germline" &&
    x.id !== "cancerSamplesIARCTP53Somatic"
  );
});

export const variantPageCardsGermlineUnordered = [
  cards.variantDetails,
  cards.genes,
  cards.acmg,
  cards.clinVar,
  cards.lovd,
  cards.uniprotVariants,
  cards.communityContributions,
  cards.publications,
  cards.transcripts,
  cards.frequencies,
  cards.mitomap,
  cards.dvd,
  cards.omim,
  cards.conservationScores,
  cards.pathogenicityScores,
  // cards.spliceVault,
  cards.expressionData,
  cards.pharmGKB,
  cards.gwas,
  cards.regionBrowser,
  cards.structuralVariants,
  cards.beaconNetwork,
  cards.proteinViewer,
  cards.clinGen,
];

export const variantPageCardsGermline = [
  // addClinicalCards ? cards.portalPublications : null,
  ...variantPageCardsGermlineUnordered.filter((x) => x.category === general),
  ...variantPageCardsGermlineUnordered.filter((x) => x.category === amp),
  ...variantPageCardsGermlineUnordered.filter((x) => x.category === acmg),
  ...variantPageCardsGermlineUnordered.filter((x) => x.category === misc),
].filter(Boolean);

export const transcriptPageCards = [
  cards.transcriptDetails,
  cards.regionBrowser,
  cards.structuralVariants,
  cards.additionalRangeLinks,
];

export const positionPageCards = [
  cards.regionBrowser,
  addClinicalCards ? cards.sampleView : null,
  addClinicalCards ? cards.dellyCNVBrowser : null,
  addClinicalCards ? cards.cnvBrowser : null,
  cards.structuralVariants,
  cards.additionalRangeLinks,
].filter(Boolean);

export const cnvPageCards = [
  cards.cnvDetails,
  cards.acmgCnvClassification,
  cards.publications,
  cards.cnvRegionBrowser,
  cards.cnvTranscripts,
];
